import { compose, mdsWidget } from 'dojo/_base/declare';
import { PlanningObjectOperator, SaleClasses } from "./PlanningObjectOperatorTypes";
import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import lang from 'dojo/_base/lang';
import PlanningObjectOperatorEditor from './PlanningObjectOperatorEditor';
import _WidgetBase from 'dijit/_WidgetBase';

class PlanningObjectOperatorView extends compose(_EntityViewMixin<PlanningObjectOperator>) {
    //templateString = template;

    private _loadingRequest: dojo.request.Promise<any> = null;
    private editingVisible: boolean = false;

    private actionNode: HTMLElement;
    private contentNode: HTMLElement;

    private _additionalRequestParams: Object = null;

     /**
     *
     * @param entityId
     * @param label
     * @param additionalParams
     * @param tabContainerName Name des Tabcontainers, in die die Ansicht ggf. maximiert werden kann
     * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
     * @param disableDefaultButtons Entfernt die Standardbuttons für Reports, Löschen und sonstige Entity-Interaktionen. Neue Buttons können mit addButton eingefügt werden.
     */
    setup(entityId: string,
        label: string,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string) {

        if (additionalParams) {
            this.config.additionalRequestParams = lang.clone(additionalParams);
        }

        if (contextName) this.setContextName(contextName);

        this.showAsDlg(entityId, label, tabContainerName);


    }

    onShow() {
        if (/*this.useDefaultButtons !== false*/ true) {
            this.handleAdditionalButtons();
        }
    }

    private handleAdditionalButtons() {
        this.requestContextButton({
            callback: lang.hitch(this, this._onClickSetStatusDone),
            label: this.translate("PlanningObjectOperator_Label_SetStatusDone"),
            iconClass: "fas fa-check successTXT",
            enabled: true,
            permanent: false,
            name: "setStatusDone",
        })
    }

    private _onClickSetStatusDone() {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__PlanningObjectOperator_SetStatusDone",
            { entityId: this.getEntityId() },
            lang.hitch(this, this._onSetStatusDoneResponse),
            lang.hitch(this, this._SetStatusDoneError)
        )
    }

    private _onSetStatusDoneResponse(response) {
        this.StandbyStop();
        this.reload();
        this.emit("change");
    }

    private _SetStatusDoneError(error) {
        this.StandbyStop();
        console.error(error);
    }

    protected onRequestEditor(entityID: string, entity: PlanningObjectOperator): MdsLax<InstanceType<typeof _WidgetBase>> {
        let editor = new PlanningObjectOperatorEditor();

        editor.setup(entityID);
        //editor.on("saved", lang.hitch(this, this.emit, "change"));
        //editor.on("deleted", lang.hitch(this, this.emit, "deleted"));

        return editor;
    }

    protected afterDelete(): void {
        this.showToast(this.translate("PlanningObjectOperator_Message_DeleteSuccess"), "fas fa-check");
    }

    postCreate(): void {

        this.config = {
            entityClassname: SaleClasses.PlanningObjectOperator,
            labelProperty: "$Displayname",
            entityClassPrintname: this.translate("General_Label_PlanningObjectOperator"),
            editOptions: {
                userroleEdit: "PlanningObjectOperator_Edit",
                featurePathEdit: null,    
                onChangedEventName: "change",
                onDeletedEventName: "deleted",
                onSavedEventName: "saved"
            },
            deleteOptions: {
                featurePathDelete: null,
                userroleDelete: "PlanningObjectOperator_Delete",
            },
            cloneOptions: {
                
                featurePathClone: null,
                //deleteEntityFunctionname: "f_Webtool_EntityView_delete",
                userroleClone: "PlanningObjectOperator_Copy",
            }
            
            
            
            
            //requestDataFunctionname: "f_Webtool_EntityView_getData"
        }
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PlanningObjectOperatorView);